import { ErrorIcon } from '@room-match/shared-ui-components';
import { RepresentativeErrorUICanvas, RepresentativeErrorUIContainer } from './RepresentativeErrorUI.styles';
import { Button, Typography } from '@material-ui/core';

type RepresentativeErrorUIProps = {
  onButtonClick?: VoidFunction;
  message?: string;
  buttonText?: string;
};

const DEFAULT_MESSAGE = 'There was a problem getting your Profiles';

const RepresentativeErrorUI = ({ onButtonClick, message, buttonText }: RepresentativeErrorUIProps) => {
  return (
    <RepresentativeErrorUICanvas>
      <RepresentativeErrorUIContainer>
        <ErrorIcon />
        <Typography style={{ fontSize: 'inherit', textAlign: 'center' }}>{message || DEFAULT_MESSAGE}</Typography>
        <Button
          onClick={() => (onButtonClick ? onButtonClick() : undefined)}
          variant="contained"
          color="primary"
          size="small"
        >
          {buttonText || 'Try again'}
        </Button>
      </RepresentativeErrorUIContainer>
    </RepresentativeErrorUICanvas>
  );
};

export default RepresentativeErrorUI;
